$(function(){


    // wt-watch Start

    // $('.j-wt-animate').slick({
    //     infinite: false,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     autoplay: false,
    //     arrows: true,
    //     dots: true,
    //     fade: true,
    //     appendArrows: $('.appendArrows')
    // });
    
    $('.j-wt-animate').on('afterChange', function(event, slick, currentSlide, nextSlide){
        
        var currentSlide = $('.j-wt-animate .slick-active').data('slick-index');
        //console.log('Current slide:' + currentSlide); // Starts at 0 index
        var classes = 'animate-0 animate-1 animate-2 animate-3 animate-4 animate-5 animate-6';
        $('.wt-watch').removeClass(classes).addClass('animate-' + currentSlide)
    
    });
    
    
        // if ( $('.world-timer-wrapper').visible( true ) ){
    
        //     //console.log('Visible');
        //     setTimeout(function(){
        //         $('.wt-watch').addClass('visible');
        //     }, 2000);
    
        // }
    





 //stopwatch end
$('.stopwatch').each(function () {


	        setTimeout(function(){
	        }, 300);

	        // Cache very important elements, especially the ones used always
	        var element = $(this);
	        var running = element.data('autostart');
	        var hoursElement = element.find('.hours');
	        var minutesElement = element.find('.minutes');
	        var secondsElement = element.find('.seconds');
	        var millisecondsElement = element.find('.milliseconds');
	        var toggleElement = element.find('.toggle');
	        var resetElement = element.find('.reset');
	        var startText = toggleElement.text();

	        // And it's better to keep the state of time in variables 
	        // than parsing them from the html.
	        var hours, minutes, seconds, milliseconds, timer;

	        function prependZero(time, length) {
	            // Quick way to turn number to string is to prepend it with a string
	            // Also, a quick way to turn floats to integers is to complement with 0
	            time = '' + (time | 0);
	            // And strings have length too. Prepend 0 until right.
	            while (time.length < length) time = '0' + time;
	            return time;
	        }


			var clock_angles = {};

			function setClock() {
	
				// Get the local time using JS
				var date = new Date;
				var seconds = date.getSeconds() + (date.getMilliseconds()/1000);
				var minutes = date.getMinutes() + (date.getSeconds()/60);
				var hours = date.getHours();
	
				// Create an object with each hand and it's angle in degrees
				clock_angles.hours = (hours * 30) + (minutes / 2);
				clock_angles.minutes = (minutes * 6);
				clock_angles.seconds = (seconds * 6);
	
			}
	
	
			function moveHands() {
	
				$('.chrono-left-seconds-container').css('webkitTransform', 'rotateZ('+ clock_angles.seconds +'deg)');
				$('.chrono-left-seconds-container').css('transform', 'rotateZ('+ clock_angles.seconds +'deg)');
	
				$('.minutes-container').css('webkitTransform', 'rotateZ('+ clock_angles.minutes +'deg)');
				$('.minutes-container').css('transform', 'rotateZ('+ clock_angles.minutes +'deg)');
	
				$('.hours-container').css('webkitTransform', 'rotateZ('+ clock_angles.hours +'deg)');
				$('.hours-container').css('transform', 'rotateZ('+ clock_angles.hours +'deg)');
			}
	
			(function() {
	
				setInterval(function() {
					setClock();
					moveHands();
				}, 100);
	
			})();

	        function setStopwatch(hours, minutes, seconds, milliseconds) {
	            // Using text(). html() will construct HTML when it finds one, overhead.
	            hoursElement.text(prependZero(hours, 2));
	            minutesElement.text(prependZero(minutes, 2));
	            secondsElement.text(prependZero(seconds, 2));
	            millisecondsElement.text(prependZero(milliseconds, 3));

	        }

	        // Update time in stopwatch periodically - every 25ms
	        function runTimer() {
	            // Using ES5 Date.now() to get current timestamp            
	            var startTime = Date.now();
	            var prevHours = hours;
	            var prevMinutes = minutes;
	            var prevSeconds = seconds;
	            var prevMilliseconds = milliseconds;

	            timer = setInterval(function () {
					//console.log('boop');
	                var timeElapsed = Date.now() - startTime;
	               
	                hours = (timeElapsed / 3600000) + prevHours;
	                minutes = ((timeElapsed / 60000) + prevMinutes) % 60;
	                seconds = ((timeElapsed / 1000) + prevSeconds) % 60;
	                milliseconds = (timeElapsed + prevMilliseconds) % 1000;

	                setStopwatch(hours, minutes, seconds, milliseconds);

	                //$('.milliseconds-container').css('webkitTransform', 'rotateZ('+ seconds * 6 +'deg)');
	                //$('.milliseconds-container').css('transform', 'rotateZ('+ seconds * 6 +'deg)');

	                $('.milliseconds-container').css('transform', 'rotateZ('+ seconds * 6 +'deg)');
	                $('.milliseconds-container').css('transform', 'rotateZ('+ seconds * 6 +'deg)');


	                $('.minutes-right-container').css('webkitTransform', 'rotateZ('+ minutes * 12 +'deg)');
	                $('.minutes-right-container').css('transform', 'rotateZ('+ minutes * 12 +'deg)');

	                $('.chrono-minutes-container').css('webkitTransform', 'rotateZ('+ minutes * 12 +'deg)');
	                $('.chrono-minutes-container').css('transform', 'rotateZ('+ minutes * 12 +'deg)');

	                $('.chrono-twelve-container').css('webkitTransform', 'rotateZ('+ (hours * 30) + (minutes / 2) + 'deg)');
	                $('.chrono-twelve-container').css('transform', 'rotateZ('+ ((hours * 30) + (minutes / 2)) + 'deg)');
	            }, 25);
	        }

	        // Split out timer functions into functions.
	        // Easier to read and write down responsibilities
	        function run() {
	            running = true;
	            runTimer();
	        }

	        function pause() {
	            running = false;
	            clearTimeout(timer);
	        }

	        function reset() {
	            running = false;
	            pause();
	            hours = minutes = seconds = milliseconds = 0;
	            setStopwatch(hours, minutes, seconds, milliseconds);
	            toggleElement.text(startText);


	            //$('.milliseconds-container').css('webkitTransform', 'rotateZ(0deg)');
	            //$('.milliseconds-container').css('transform', 'rotateZ(0deg)');

	            $('.minutes-right-container').css('webkitTransform', 'rotateZ(0deg)');
	            $('.minutes-right-container').css('transform', 'rotateZ(0deg)');

	            $('.chrono-minutes-container').css('webkitTransform', 'rotateZ(0deg)');
	            $('.chrono-minutes-container').css('transform', 'rotateZ(0deg)');

	            $('.milliseconds-container').css('webkitTransform', 'rotateZ(0deg)');
	            $('.milliseconds-container').css('transform', 'rotateZ(0deg)');

	            $('.chrono-twelve-container').css('webkitTransform', 'rotateZ(0deg)');
	            $('.chrono-twelve-container').css('transform', 'rotateZ(0deg)');
	        }

	        // And button handlers merely call out the responsibilities
	        toggleElement.on('click', function () {
	            (running) ? pause() : run();
	            $this = $(this);
	            $this.addClass('pressed');
	            setTimeout(function(){
	                $this.removeClass('pressed');
	                $('.ripple:first').fadeOut('slow');
	            }, 300);
	        });

	        resetElement.on('click', function () {
	            reset();
	            $this = $(this);
	            $this.addClass('pressed');
	            setTimeout(function(){
	                $this.removeClass('pressed');
	                $('.ripple:last').fadeOut('slow');
	            }, 300);
	        });

	        // Another advantageous thing about factoring out functions is that
	        // They are reusable, callable elsewhere.
	        reset();
	        if(running) run();
	    });

    
    });